
export const baseUrl = (env = 'APP_SERVER_URL') => {

    if (process.env.REACT_APP_ENV === 'production') {
        return `${document.URL.split('.com')[0]}.com`
    }

    const flagRewrite = eval(process.env.REACT_APP_REWRITE_DOMINIO) || false

    return ({
        APP_URL: process.env.REACT_APP_URL,
        APP_SERVER_URL: process.env.REACT_APP_ENV === 'development' && flagRewrite
            ? document.URL.split(':').slice(0, 2).join(':') + ':1051'
            : process.env.REACT_APP_SERVER_URL
    }[env])
}